import { render } from "./SupportedLanguagesMenu.vue?vue&type=template&id=28466c22&scoped=true"
import script from "./SupportedLanguagesMenu.vue?vue&type=script&lang=js"
export * from "./SupportedLanguagesMenu.vue?vue&type=script&lang=js"

import "./SupportedLanguagesMenu.vue?vue&type=style&index=0&id=28466c22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28466c22"]])

export default __exports__